<template>
  <div class="wrap-phone">
    <!-- 手机号验证 -->
    <el-form :model="ruleForm" ref="ruleForm" class="regin-info" :rules="rules">
      <div class="title">联系人手机号码<span>( 11位手机号 )</span></div>
      <el-row class="input">
        <el-col :span="15">
          <el-form-item prop="contactMobile">
            <el-input placeholder="11位手机号" v-model="ruleForm.contactMobile"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-button type="primary" @click="sendCode" id="code" :disabled="sendFlag">发送验证码</el-button>
        </el-col>
      </el-row>
      <div class="title">短信验证码<span>( 4位数字 )</span></div>
      <el-form-item class="input" prop="smsAuthCode">
        <el-input placeholder="4位数字" v-model="ruleForm.smsAuthCode"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="btn">
          <el-button @click="back">返回</el-button>
          <el-button type="primary" @click="register">{{selectedLevel==2?'绑定手机号':'完成验证，下一步'}}</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  requestUrl,
  ajax,
  checkLogin,
  getQueryString,
} from "@/assets/utils/network";
export default {
  props: ["selectedLevel"],
  data() {
    // 验证验证码是否正确
    var checkcode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (isNaN(value)) {
        callback(new Error("请输入数字值"));
      } else if (value.toString().length !== 4) {
        callback(new Error("请输入4位数字"));
      } else {
        callback();
      }
    };
    return {
      interval: null,
      sendFlag: false, // 发送手机验证码的开关
      ruleForm: {
        contactMobile: "",
        smsAuthCode: "",
      },
      rules: {
        // 校验规则
        contactMobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        // 短信验证码
        smsAuthCode: [
          {
            validator: checkcode,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 发送验证码
    sendCode() {
      var info = new Object();
      info.mobile = this.ruleForm.contactMobile;
      if (info.mobile == "" || info.mobile.length != 11) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      ajax({
        type: "POST",
        url: requestUrl + "/smsauthcode",
        data: JSON.stringify(info),
        dataType: "json",
        success: function (response) {},
        fail: function (response) {
          om.$message.error("服务器响应超时");
        },
      });
      let time_num = 60;
      let that = this;
      this.sendFlag = true;
      var t = setInterval(function () {
        if (--time_num < 1) {
          clearInterval(t);
          that.sendFlag = false;
          document
            .getElementById("code")
            .getElementsByTagName("span")[0].innerText = "获取验证码";
        } else document.getElementById("code").getElementsByTagName("span")[0].innerText = time_num + "s后重新获取";
      }, 1000);
      this.interval = t;
    },
    // 注册--下一步
    register() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          clearInterval(this.interval);
          this.$emit("next", {
            codeInfo: this.ruleForm,
            stepActive: "2",
            tag: "phone",
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 返回
    back() {
      this.$emit("next", {
        stepActive: this.selectedLevel == 1 ? "0" : "1",
        tag: "back",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-phone {
  margin-top: 20%;
}
.title-all {
  color: #464b5c;
  font-size: 14px;
  margin-bottom: 10px;
  span {
    color: #8087a0;
  }
}
.regin-info {
  .title {
    @extend .title-all;
  }
  .btn {
    text-align: center;
  }
}
</style>